import { REPORTS_NAMESPACE_TRANSLATIONS } from "./reports-namespace-translations.ts"
import { REPORTS_TRANSLATIONS } from "./reports-translations.ts"
import { COW_STATUS_TRANSLATIONS } from "@/locales/fr/cow-status-translations.ts"
import { FR_MAIN_TRANSLATIONS } from "@/locales/fr/main-translations.ts"

export const FR_TRANSLATIONS = {
  translation: {
    ...FR_MAIN_TRANSLATIONS,
    ...REPORTS_TRANSLATIONS,
  },
  cowStatus: {
    ...COW_STATUS_TRANSLATIONS,
  },
  reports: { ...REPORTS_NAMESPACE_TRANSLATIONS },
}
